import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import privacyPolicy from './modules/privacy-policy'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    privacyPolicy
  },
  getters,
  mutations,
  actions,
  strict: true,
  plugins: [createPersistedState({
    key: 'LuxTag',
    paths: ['user']
  })]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js